import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import Header from './Header';
import SideBar from './SideBar';
import Home from './Home';
import UserMaster from '../admin/UserMaster';
import RoleMaster from '../admin/RoleMaster';
import MenuMaster from '../admin/MenuMaster';
import DivisionMaster from '../admin/DivisionMaster';
import TenantMaster from '../admin/TenantMaster';
import AuditTrail from '../admin/AuditTrail';
import RouteGuard from '../common/RouteGuard';
import IodUpdate from '../iod/IodUpdate';
import IodReverse from '../iod/IodReverse';
import IodUserMaster from '../admin/IodUserMaster';
import IodRoleMaster from '../admin/IodRoleMaster';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import useSessionTimeout from '../../hooks/useSessionTimeout';
import SessionTimeoutModal from '../common/SessionTimeoutModal';

const Main = () => {
  const { accounts } = useMsal();
  const [userInfo, setUserInfo] = useState(null);
  const [authLoaded, setAuthLoaded] = useState(false);
  const [sidebar, setSidebar] = useState('closed');
  const { showTimeoutModal, handleLogout, handleContinueSession } = useSessionTimeout();

  useEffect(() => {
    if (accounts.length > 0) {
      setUserInfo(accounts[0]);
      loadUserAuthorization(accounts[0]);
    }
  }, [accounts]);

  const loadUserAuthorization = async (account) => {
    try {
      const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');
      if (userData.authorizedSessions) {
        sessionStorage.setItem('AuthorizedSessions', JSON.stringify(userData.authorizedSessions));
        sessionStorage.setItem('Role', userData.role);
        sessionStorage.setItem('Email', userData.userId);
      }
    } catch (error) {
      console.error('Error loading authorization:', error);
    } finally {
      setAuthLoaded(true);
    }
  };

  if (!userInfo || !authLoaded) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <div className={`home ${sidebar}`}>
        <div className="side-bar">
          <SideBar sidebar={sidebar} setSidebar={setSidebar} />
        </div>
        <div className="center-panel">
          <Header sidebar={sidebar} setSidebar={setSidebar} />
          <div className="main-body">
            <Routes>
              <Route path="/" element={<Navigate to="dashboard" replace />} />
              <Route path="/dashboard" element={<Home />} />
              <Route path="/logging" element={<AuditTrail />} />
              <Route path="/users" element={<RouteGuard><UserMaster /></RouteGuard>} />
              <Route path="/roles" element={<RouteGuard><RoleMaster /></RouteGuard>} />
              <Route path="/menu-master" element={<RouteGuard><MenuMaster /></RouteGuard>} />
              <Route path="/division-master" element={<RouteGuard><DivisionMaster /></RouteGuard>} />
              <Route path="/tenant-master" element={<RouteGuard><TenantMaster /></RouteGuard>} />
              <Route path="/iod-update" element={<RouteGuard><IodUpdate /></RouteGuard>} />
              <Route path="/iod-reverse" element={<RouteGuard><IodReverse /></RouteGuard>} />
              <Route path="/iod-users" element={<RouteGuard><IodUserMaster /></RouteGuard>} />
              <Route path="/iod-roles" element={<RouteGuard><IodRoleMaster /></RouteGuard>} />
            </Routes>
          </div>
        </div>
        <ToastContainer position="top-right" />
        <SessionTimeoutModal 
          show={showTimeoutModal} 
          onContinue={handleContinueSession}
          onLogout={handleLogout} 
        />
      </div>
    </Router>
  );
};

export default Main;
